import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  RouteComponentProps,
  Redirect,
} from "react-router-dom";
import Layout from "./components/containers/Layout";
import LoginRequiredRoute from "./routes/LoginRequiredRoute";
import Login from "./pages/Login";
import routes from "./routes";
import PermissionRequiredRoute from "./routes/PermissionRequiredRoute";
import AppDataLoadedFirst from "./components/middleware/AppDataLoadedFirst";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function AppRouter() {
  let routeComponents: React.ReactElement[] = [];
  for (const key in routes) {
    const route = routes[key];

    // Función que devuelve el layout con los wrappers necesarios
    const renderWithWrappers = (props: RouteComponentProps) => {
      let layout = <Layout {...props} />;

      if (route.permissionName) {
        layout = (
          <AppDataLoadedFirst>
            <PermissionRequiredRoute permissionName={route.permissionName}>
              {layout}
            </PermissionRequiredRoute>
          </AppDataLoadedFirst>
        );
      } else {
        layout = <AppDataLoadedFirst>{layout}</AppDataLoadedFirst>;
      }

      return layout;
    };

    routeComponents.push(
      <LoginRequiredRoute
        key={key}
        path={route.path}
        exact={route.exact}
        render={renderWithWrappers}
      />
    );
  }
  return (
    <Router>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route path="/login" component={Login} />
          {routeComponents}
          <Redirect from="/" to="/dashboard" />
        </Switch>
      </React.Suspense>
    </Router>
  );
}

export default AppRouter;
